<template>
  <v-card flat :class="`pa-7 clickable ${(station.status ? 'online' : 'offline')}`"
    :to="`/station/${station.name}@${station.userId}`"
    style="position: relative; min-height: 80px;">
    <div :class="['station-status-bar', station.status ? 'station-status-online' : 'station-status-offline']"></div>
    <v-layout row wrap style="margin-left: 12px;">
      <v-flex xs6 sm4 md3 lg2 xl2>
        <h3 class="caption grey--text">Station Name</h3>
        <div><strong>{{ station.name }}</strong></div>
      </v-flex>
      <v-flex xs6 sm4 md3 lg2 xl1>
        <div class="caption grey--text text-center">Listening</div>
        <div class="text-center">{{ station.satellite }}</div>
      </v-flex>
      <v-flex xs6 sm4 md3 lg1 xl1>
        <div class="caption grey--text text-center">Version</div>
        <div class="text-center">{{ station.version }}</div>
      </v-flex>
      <v-flex xs6 sm4 md3 lg1 xl1>
        <div v-if="station.status == 1" class="caption grey--text text-center">
          Last packet
        </div>
        <div v-else class="caption grey--text text-center">
          Last seen
        </div>
        <div v-if="station.status == 1" class="text-center">
          {{ dateSince(station.lastPacketTime) }}
        </div>
        <div v-else class="text-center">
          {{ dateSince(station.lastSeen) }}
        </div>
      </v-flex>
      <v-flex flex-grow-1>
        <div class="caption grey--text text-center">Auto tune</div>
        <div class="text-center">{{ station.autoTune ? station.autoTune : "OFF" }}</div>
      </v-flex>
      <v-flex flex-grow-1>
        <div class="caption grey--text text-center">Test mode</div>
        <div class="text-center">{{ station.test ? "ON" : "OFF" }}</div>
      </v-flex>
      <v-flex flex-grow-1>
        <div class="caption grey--text text-center">Telemetry packets</div>
        <div class="text-center">{{ station.telemetryPackets.toLocaleString() }}</div>
      </v-flex>
      <v-flex flex-grow-1>
        <div class="caption grey--text text-center">Confirmed packets</div>
        <div class="text-center">{{ station.confirmedPackets.toLocaleString() }}</div>
      </v-flex>
      <v-flex v-if="station.local_ip" flex-grow-1 class="text-right">
        <v-btn color="primary" class="lighten-1 text-center mt-3" depressed @click.stop=""
          :to="`/station/${station.name}@${station.userId}`">
          <span>Ground Control</span>
          <v-icon right>mdi-monitor-dashboard</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script setup>
import moment from 'moment'

defineProps({
  station: {
    type: Object,
    required: true
  }
})

function dateSince(time) {
  if (!time) return "Never"
  return moment(time).fromNow()
}
</script>

<style scoped>
.online {
  border-left: 4px solid var(--v-success-base) !important;
}
.offline {
  border-left: 4px solid var(--v-error-base) !important;
}
.station-status-bar {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 6px;
  border-radius: 3px;
  z-index: 10;
}
.station-status-online {
  background: var(--v-success-base, #4caf50);
}
.station-status-offline {
  background: var(--v-error-base, #f44336);
}
</style>